import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'IndexTooltip',
  setup(__props) {

const BasicTooltip = defineAsyncComponent(() => import("@/components/theme/uikits/tooltip/BasicTooltip.vue"))
const ColoredTooltip = defineAsyncComponent(() => import("@/components/theme/uikits/tooltip/ColoredTooltip.vue"))
const DirectionsTooltip = defineAsyncComponent(() => import("@/components/theme/uikits/tooltip/DirectionsTooltip.vue"))
const HoverEffect = defineAsyncComponent(() => import("@/components/theme/uikits/tooltip/HoverEffect.vue"))
const FilledTooltip = defineAsyncComponent(() => import("@/components/theme/uikits/tooltip/FilledTooltip.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Ui Kits",
      mains: "Tooltip",
      title: "Tooltip"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(BasicTooltip)),
        _createVNode(_unref(ColoredTooltip)),
        _createVNode(_unref(DirectionsTooltip)),
        _createVNode(_unref(HoverEffect)),
        _createVNode(_unref(FilledTooltip))
      ])
    ])
  ], 64))
}
}

})